import { render, staticRenderFns } from "./joinLeaveInfoList.vue?vue&type=template&id=f586127a&scoped=true&"
import script from "./joinLeaveInfoList.vue?vue&type=script&lang=js&"
export * from "./joinLeaveInfoList.vue?vue&type=script&lang=js&"
import style0 from "./joinLeaveInfoList.vue?vue&type=style&index=0&id=f586127a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f586127a",
  null
  
)

export default component.exports